export const categories = [
  { slug: 'tutorial', name: '教程攻略', icon: 'ri-book-open-line', description: 'KY应用安装与使用教程，手把手教你快速上手' },
  { slug: 'news', name: '更新动态', icon: 'ri-flashlight-line', description: 'KY应用最新版本更新日志与新功能发布' },
  { slug: 'guide', name: '使用指南', icon: 'ri-compass-3-line', description: '深入探索KY应用各项功能的使用技巧' },
  { slug: 'faq', name: '常见问题', icon: 'ri-question-answer-line', description: '关于KY应用下载、安装、注册的常见疑问解答' },
];

export const articles = [
  {
    slug: 'ky-app-download-install-guide-2024',
    title: 'KY App 官方下载与安装完整教程（2024最新版）',
    excerpt: '本文将详细介绍如何通过 www.ky.app 官方入口下载并安装 KY 应用，涵盖 iOS 和 Android 双平台完整流程，确保你安全、快速完成安装。',
    category: 'tutorial',
    author: 'KY官方团队',
    date: '2024-12-15',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20article%20illustration%20with%20warm%20coral%20accents%20on%20light%20background%2C%20abstract%20geometric%20elements%2C%20clean%20editorial%20style%2C%20soft%20gradients%2C%20professional%20layout%20design%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-01&orientation=landscape',
    content: `<h2>前言</h2><p>KY App 作为一款备受用户青睐的移动应用，官方始终建议用户通过 <strong>www.ky.app</strong> 官方指定地址进行下载，以确保应用安全性和功能完整性。本教程将详细介绍 iOS 和 Android 双平台的完整安装流程。</p><h2>一、准备工作</h2><p>在开始下载之前，请确保你的设备满足以下基本条件：</p><ul><li>iOS 设备需运行 iOS 14.0 或更高版本</li><li>Android 设备需运行 Android 8.0 或更高版本</li><li>设备至少保留 500MB 可用存储空间</li><li>稳定的网络连接（推荐使用 Wi-Fi）</li></ul><h2>二、iOS 下载安装教程</h2><p>步骤一：打开 Safari 浏览器，在地址栏输入 <strong>www.ky.app</strong> 进入官方页面。</p><p>步骤二：点击首页的"iOS 下载"按钮，系统将自动跳转至 App Store 下载页面。</p><p>步骤三：在 App Store 页面点击"获取"按钮，使用 Face ID、Touch ID 或 Apple ID 密码确认安装。</p><p>步骤四：等待应用下载完成后，桌面将出现 KY App 图标，点击即可打开使用。</p><h2>三、Android 下载安装教程</h2><p>步骤一：使用手机浏览器访问 <strong>www.ky.app</strong> 官方页面。</p><p>步骤二：点击"Android 下载"按钮，系统将开始下载 APK 安装包。</p><p>步骤三：下载完成后，点击通知栏中的下载完成提示，或进入文件管理器找到下载的 APK 文件。</p><p>步骤四：点击 APK 文件，如系统提示"未知来源安装"，请在设置中允许来自浏览器的安装权限。</p><p>步骤五：按照屏幕提示完成安装，返回桌面即可找到 KY App 图标。</p><h2>四、账号注册与登录</h2><p>安装完成后，打开 KY App，你将看到欢迎页面。点击"注册新账号"，按照提示输入手机号或邮箱，设置密码后即可完成注册。已有账号的用户可直接输入账号密码登录。</p><h2>五、常见问题排查</h2><p>如果下载过程中遇到问题，请检查以下几点：</p><ul><li>确认网络连接正常</li><li>清空浏览器缓存后重试</li><li>确保设备存储空间充足</li><li>如仍无法解决，请联系官方客服</li></ul><h2>结语</h2><p>通过 <strong>www.ky.app</strong> 官方入口下载 KY App 是最安全可靠的方式。如果你在安装过程中遇到任何问题，欢迎随时联系我们的在线客服团队。</p>`,
  },
  {
    slug: 'ky-app-v3-2-update-log',
    title: 'KY App v3.2 版本更新日志 — 全新界面与性能优化',
    excerpt: 'KY App 最新 v3.2 版本正式发布，带来全新设计的用户界面、大幅性能优化以及多项功能改进。立即通过 www.ky.app 更新体验。',
    category: 'news',
    author: 'KY开发团队',
    date: '2024-12-10',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20tech%20update%20illustration%20with%20coral%20amber%20gradient%20and%20digital%20elements%2C%20clean%20minimalist%20editorial%20style%2C%20soft%20glowing%20accents%2C%20professional%20design%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-02&orientation=landscape',
    content: `<h2>版本概述</h2><p>KY App v3.2 版本于 2024年12月10日正式发布，本次更新聚焦于用户体验提升和性能优化，为用户带来更流畅、更美观的使用体验。</p><h2>全新界面设计</h2><p>v3.2 版本采用了全新的设计语言，优化了信息层级和视觉动线：</p><ul><li>重新设计的首页布局，核心功能触达更便捷</li><li>全新的图标系统和色彩方案</li><li>优化了深色模式下的视觉体验</li><li>更流畅的页面过渡动画</li></ul><h2>性能优化</h2><p>开发团队在性能方面做了大量工作：</p><ul><li>应用启动速度提升 40%</li><li>内存占用降低 25%</li><li>列表滑动帧率稳定 60fps</li><li>网络请求响应速度优化 30%</li></ul><h2>功能改进</h2><p>本次更新还包含了以下功能改进：</p><ul><li>新增消息推送分类管理</li><li>优化了账号安全验证流程</li><li>修复了若干已知问题</li></ul><h2>如何更新</h2><p>请访问 <strong>www.ky.app</strong> 获取最新版本，或直接在应用内检查更新。iOS 用户可在 App Store 中更新，Android 用户可通过官方 APK 更新。</p>`,
  },
  {
    slug: 'ky-app-register-login-guide',
    title: 'KY App 账号注册与登录完整指南',
    excerpt: '详解 KY App 的账号注册流程、登录方式以及账号安全管理建议，帮助你快速完成注册并保障账号安全。',
    category: 'tutorial',
    author: 'KY官方团队',
    date: '2024-12-05',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20digital%20security%20illustration%20with%20warm%20coral%20shield%20icon%20on%20light%20background%2C%20abstract%20minimalist%20style%2C%20soft%20gradient%20touches%2C%20professional%20editorial%20design%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-03&orientation=landscape',
    content: `<h2>注册前准备</h2><p>在注册 KY App 账号之前，请准备好以下信息：</p><ul><li>有效的手机号码或电子邮箱地址</li><li>设置一个安全强度较高的密码（建议8位以上，包含字母和数字）</li></ul><h2>手机号注册流程</h2><p>步骤一：打开 KY App，点击"注册新账号"按钮。</p><p>步骤二：选择"手机号注册"，输入你的手机号码，点击"获取验证码"。</p><p>步骤三：输入收到的短信验证码，设置登录密码。</p><p>步骤四：填写昵称等基本信息，完成注册。</p><h2>邮箱注册流程</h2><p>步骤一：打开 KY App，点击"注册新账号"按钮。</p><p>步骤二：选择"邮箱注册"，输入你的电子邮箱地址。</p><p>步骤三：系统将向你的邮箱发送验证邮件，点击邮件中的链接完成验证。</p><p>步骤四：设置登录密码并填写基本信息，完成注册。</p><h2>账号安全建议</h2><ul><li>建议开启双重验证功能</li><li>定期修改密码</li><li>不要在公共设备上保存登录状态</li><li>警惕钓鱼网站，始终通过 www.ky.app 访问</li></ul>`,
  },
  {
    slug: 'ky-app-features-overview',
    title: 'KY App 核心功能全面解析 — 为什么选择 KY',
    excerpt: '深入了解 KY App 的核心功能模块，从智能推荐到隐私保护，全面展示 KY App 的独特优势与使用价值。',
    category: 'guide',
    author: 'KY产品团队',
    date: '2024-11-28',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20product%20feature%20showcase%20illustration%20with%20warm%20coral%20and%20amber%20elements%20on%20clean%20light%20background%2C%20abstract%20geometric%20layout%2C%20minimalist%20editorial%20design%2C%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-04&orientation=landscape',
    content: `<h2>产品理念</h2><p>KY App 始终以用户体验为核心，致力于打造一款安全、稳定、高效的移动应用。我们相信，好的产品应该让用户用得放心、用得舒心。</p><h2>核心功能一：智能推荐引擎</h2><p>KY App 搭载了先进的智能推荐算法，能够根据用户的使用习惯和偏好，精准推荐相关内容，让每一次使用都充满惊喜。</p><h2>核心功能二：隐私安全保障</h2><p>在数据安全方面，KY App 采用了行业领先的加密技术，确保用户数据在传输和存储过程中的安全性。我们承诺：不泄露、不滥用任何用户数据。</p><h2>核心功能三：极速响应体验</h2><p>经过深度优化的底层架构，KY App 能够在各种网络环境下保持流畅的响应速度。无论是内容加载还是功能切换，都能做到毫秒级响应。</p><h2>核心功能四：多端数据同步</h2><p>支持 iOS、Android 多端登录，账号数据实时同步，随时随地无缝切换设备使用。</p><h2>用户权益保障</h2><ul><li>7×24小时在线客服支持</li><li>定期安全审计与漏洞修复</li><li>持续的功能迭代与优化</li><li>透明的隐私政策与数据使用说明</li></ul>`,
  },
  {
    slug: 'ky-app-faq-common-issues',
    title: 'KY App 常见问题汇总 — 下载安装登录一篇搞定',
    excerpt: '汇总 KY App 用户最常遇到的问题及解决方案，覆盖下载失败、安装报错、登录异常、闪退等各类问题的排查方法。',
    category: 'faq',
    author: 'KY客服团队',
    date: '2024-11-20',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20help%20desk%20support%20illustration%20with%20warm%20coral%20question%20mark%20icon%20on%20light%20background%2C%20minimalist%20editorial%20style%2C%20abstract%20soft%20shapes%2C%20professional%20design%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-05&orientation=landscape',
    content: `<h2>下载相关问题</h2><h3>Q：下载速度很慢怎么办？</h3><p>A：请检查你的网络连接状态，建议切换到 Wi-Fi 环境下载。如果 Wi-Fi 下载仍然很慢，可以尝试重启路由器或切换网络环境后重试。</p><h3>Q：下载到一半就中断了？</h3><p>A：这通常是由于网络不稳定导致的。请清理浏览器缓存后重新访问 www.ky.app 进行下载，或尝试使用其他浏览器。</p><h2>安装相关问题</h2><h3>Q：Android 安装时提示"解析包错误"？</h3><p>A：请确认下载的 APK 文件完整未损坏，建议删除后重新从 www.ky.app 下载。同时检查手机系统版本是否满足最低要求（Android 8.0+）。</p><h3>Q：iOS 安装时提示"无法安装此 App"？</h3><p>A：请确认你的 iOS 版本为 14.0 或更高版本。前往"设置 &gt; 通用 &gt; iPhone 存储空间"清理空间后重试。</p><h2>登录相关问题</h2><h3>Q：忘记密码怎么办？</h3><p>A：在登录页面点击"忘记密码"，按照提示通过手机号或邮箱重置密码即可。</p><h3>Q：收不到验证码？</h3><p>A：请检查手机号是否输入正确，确认短信未被拦截软件过滤。如超过 2 分钟仍未收到，可点击"重新发送"。</p><h2>使用相关问题</h2><h3>Q：应用频繁闪退？</h3><p>A：建议尝试以下步骤：1）清理应用缓存；2）重新启动手机；3）卸载后从 www.ky.app 重新下载安装最新版本。</p>`,
  },
  {
    slug: 'ky-app-security-privacy',
    title: 'KY App 安全与隐私保护白皮书',
    excerpt: 'KY App 安全架构与技术方案详解，了解我们如何通过多层加密、权限控制和合规审计保障你的数据安全与隐私。',
    category: 'guide',
    author: 'KY安全团队',
    date: '2024-11-15',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cyber%20security%20shield%20illustration%20with%20warm%20coral%20glow%20on%20clean%20light%20background%2C%20abstract%20minimalist%20tech%20style%2C%20soft%20gradient%20accents%2C%20professional%20editorial%20design%2C%20no%20text%2C%20no%20people&width=600&height=400&seq=article-img-06&orientation=landscape',
    content: `<h2>安全承诺</h2><p>在 KY App，我们视用户数据安全为生命线。我们构建了一套完整的、经过行业认证的安全防护体系，确保每一位用户的数据都能得到最严格的保护。</p><h2>数据传输加密</h2><p>所有 KY App 与服务器之间的数据传输均采用 TLS 1.3 协议进行加密，确保数据在传输过程中不被窃取或篡改。同时我们启用了证书锁定（Certificate Pinning）技术，防止中间人攻击。</p><h2>数据存储安全</h2><p>用户敏感数据在服务器端使用 AES-256 算法进行加密存储，密钥采用硬件安全模块（HSM）进行管理。即使是我们的工程师也无法直接访问原始用户数据。</p><h2>隐私权限控制</h2><p>KY App 严格遵循最小权限原则：</p><ul><li>仅申请功能必需的权限</li><li>权限使用透明可见</li><li>用户可随时撤销已授权的权限</li><li>后台权限使用有明确提示</li></ul><h2>合规与审计</h2><p>我们定期邀请第三方安全机构进行渗透测试和安全审计，确保安全防护体系持续有效。</p>`,
  },
];

export const reviews = [
  {
    id: 1,
    name: '王先生',
    role: '资深用户，使用2年',
    rating: 5,
    content: '用 KY App 两年了，一直很稳定流畅。官方下载渠道 www.ky.app 下载速度也很快，安装简单，推荐给大家！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%20with%20clean%20white%20background%2C%20business%20casual%20style%2C%20warm%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20headshot%20photography%2C%20minimal%20and%20professional&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '李女士',
    role: '新用户，使用3个月',
    rating: 5,
    content: '朋友推荐来的，在 www.ky.app 下载的，安装过程很顺利。App 功能齐全，客服响应也很快，体验很好。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%20with%20clean%20white%20background%2C%20modern%20casual%20style%2C%20warm%20confident%20smile%2C%20soft%20studio%20lighting%2C%20headshot%20photography%2C%20minimal%20and%20professional&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '张先生',
    role: '技术爱好者，使用1年',
    rating: 5,
    content: '作为技术人员，我对应用的安全性和性能要求很高。KY App 在隐私保护和响应速度方面都做得很出色，值得信赖。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%20with%20clean%20white%20background%2C%20tech%20casual%20style%20with%20glasses%2C%20friendly%20professional%20expression%2C%20soft%20studio%20lighting%2C%20headshot%20photography%2C%20minimal&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    id: 4,
    name: '赵女士',
    role: '学生用户，使用半年',
    rating: 4,
    content: '界面设计很好看，操作也不复杂。在 www.ky.app 官方下载很安心，不用担心下载到修改版或者带病毒的应用。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%20with%20clean%20white%20background%2C%20young%20student%20casual%20style%2C%20bright%20warm%20smile%2C%20soft%20studio%20lighting%2C%20headshot%20photography%2C%20minimal%20fresh&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
];

export const faqs = [
  {
    q: 'www.ky.app 是官方下载地址吗？',
    a: '是的，www.ky.app 是 KY 应用的唯一官方指定下载地址。我们建议所有用户仅通过此地址下载，以确保应用的安全性和功能完整性。',
  },
  {
    q: 'KY App 支持哪些平台？',
    a: 'KY App 目前支持 iOS（14.0及以上版本）和 Android（8.0及以上版本）两大主流移动平台，用户可通过 www.ky.app 选择对应平台进行下载。',
  },
  {
    q: '下载和安装 KY App 需要付费吗？',
    a: 'KY App 的下载和安装完全免费。部分高级功能可能需要付费订阅，但基础功能对所有用户永久免费开放。',
  },
  {
    q: '如何确保下载的是最新版本？',
    a: '通过 www.ky.app 官方入口下载即可自动获取最新版本。已安装的用户可以在应用内的"设置-关于-检查更新"中确认是否为最新版。',
  },
  {
    q: '注册账号需要提供哪些信息？',
    a: '注册 KY App 账号只需要提供手机号码或电子邮箱地址，并设置登录密码即可。我们承诺严格保护你的个人信息安全。',
  },
  {
    q: '遇到问题如何联系客服？',
    a: '你可以通过 KY App 内的"我的-联系客服"功能联系在线客服，或发送邮件至 support@ky.app，我们的客服团队提供 7×24 小时服务。',
  },
  {
    q: 'KY App 的个人数据安全吗？',
    a: '是的，我们采用业界领先的加密技术保护所有用户数据。数据传输使用 TLS 1.3 加密，存储使用 AES-256 加密，并通过定期安全审计确保防护体系有效。',
  },
];

export const features = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '极速下载',
    description: '全球 CDN 加速节点，确保无论身在何处都能享受极速下载体验，几分钟即可完成安装。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '隐私保障',
    description: '多层加密技术保护用户数据，严格遵守隐私法规，让你的个人信息安全无忧。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '双平台支持',
    description: '完美适配 iOS 与 Android 平台，提供一致流畅的使用体验，随时随地畅享 KY 服务。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '稳定流畅',
    description: '深度优化的底层架构，确保应用在各种网络环境下都能保持稳定流畅的运行状态。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更新',
    description: '开发团队持续迭代优化，定期推送功能更新与安全补丁，保持应用始终处于最佳状态。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '7×24 小时在线客服支持，专业团队随时待命，快速响应并解决你在使用中遇到的任何问题。',
  },
];